import { newPasswordSettingFormSchema } from "@/features/authenticate/schemas/newPasswordSettingForm";
import type { NewPasswordSettingForm as NewPasswordSettingFormType } from "@/features/authenticate/types/newPasswordSettingForm";
import {
	Button,
	Image,
	PasswordInput,
	Stack,
	Text,
	Title,
} from "@mantine/core";
import { useForm, zodResolver } from "@mantine/form";
import { FormLayout } from "../common/FormLayout";

type Props = {
	handleSubmit: (values: NewPasswordSettingFormType) => Promise<void>;
};

export const NewPasswordSettingForm = ({ handleSubmit }: Props) => {
	const form = useForm<NewPasswordSettingFormType>({
		mode: "uncontrolled",
		initialValues: {
			newPassword: "",
			newPasswordConfirm: "",
		},
		validate: zodResolver(newPasswordSettingFormSchema),
	});

	return (
		<FormLayout>
			<Stack w={162} h={30} align="center" justify="center" mx="auto">
				<Image src="/Logo.png" alt="logo" />
			</Stack>
			<Title order={2} style={{ textAlign: "center" }}>
				パスワード再設定
			</Title>
			<form onSubmit={form.onSubmit(handleSubmit)}>
				<Stack gap="md">
					<Text style={{ textAlign: "left" }}>
						新しいパスワードを設定してください。
					</Text>
					<PasswordInput
						size="md"
						w={320}
						key={form.key("newPassword")}
						{...form.getInputProps("newPassword")}
						placeholder="新しいパスワード"
					/>
					<PasswordInput
						size="md"
						w={320}
						key={form.key("newPasswordConfirm")}
						{...form.getInputProps("newPasswordConfirm")}
						placeholder="新しいパスワードを再入力"
					/>
					<Button type="submit" fullWidth size="md">
						<Text>パスワードを再設定</Text>
					</Button>
				</Stack>
			</form>
		</FormLayout>
	);
};
